import React, { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import { FaArrowUp, FaUserMd, FaUserFriends, FaSmileBeam, FaClock } from 'react-icons/fa';
import './style/About.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function AboutUs() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const toggleScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener('scroll', toggleScroll);
    return () => window.removeEventListener('scroll', toggleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const teamMembers = [
    {
      name: 'Dr. Omar Adel',
      specialty: 'Orthopedic Specialist',
      img: 'https://randomuser.me/api/portraits/men/45.jpg'
    },
    {
      name: 'Dr. Sara Ahmed',
      specialty: 'Cardiologist',
      img: 'https://randomuser.me/api/portraits/women/68.jpg'
    },
    {
      name: 'Dr. Hany Mahmoud',
      specialty: 'Pediatrician',
      img: 'https://randomuser.me/api/portraits/men/53.jpg'
    },
    {
      name: 'Dr. Eman Youssef',
      specialty: 'Dermatologist',
      img: 'https://randomuser.me/api/portraits/women/44.jpg'
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <>
      <motion.div
        className="about-container"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h1 className="main-title">About Us</h1>
        <p className="main-desc">
          Welcome to our medical clinic! With years of experience, our professional team provides exceptional healthcare using modern technology and compassion.
        </p>

        {/* Mission & Values */}
        <div className="mission-section">
          <h2>Our Mission</h2>
          <p>
            To provide exceptional healthcare services with compassion, innovation, and integrity. Our goal is to ensure every patient receives personal and professional care.
          </p>
        </div>

        <div className="values-section">
          <h2>Our Core Values</h2>
          <div className="values-grid">
            <div className="value-box">Compassion</div>
            <div className="value-box">Integrity</div>
            <div className="value-box">Innovation</div>
            <div className="value-box">Teamwork</div>
          </div>
        </div>

        {/* Counters */}
        <div className="counters">
          {[{ icon: <FaClock />, end: 15, label: 'Years of Experience' },
            { icon: <FaUserMd />, end: 25, label: 'Expert Doctors' },
            { icon: <FaUserFriends />, end: 7000, label: 'Happy Patients' },
            { icon: <FaSmileBeam />, end: 98, label: 'Patient Satisfaction', suffix: '%' }
          ].map((item, i) => (
            <motion.div key={i} className="counter" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
              <div className="icon">{item.icon}</div>
              <h2>
                <CountUp end={item.end} duration={2.5} suffix={item.suffix || '+'} />
              </h2>
              <p>{item.label}</p>
            </motion.div>
          ))}
        </div>

        {/* Meet the Team */}
        <div className="team-section">
          <h2>Meet Our Team</h2>
          <Slider {...sliderSettings} className="team-slider">
            {teamMembers.map((member, index) => (
              <motion.div className="member-card" key={index} whileHover={{ scale: 1.05 }}>
                <img src={member.img} alt={member.name} />
                <h4>{member.name}</h4>
                <p>{member.specialty}</p>
              </motion.div>
            ))}
          </Slider>
        </div>
      </motion.div>

      {/* Scroll To Top */}
      {showScroll && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </>
  );
}
